import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        paddingLeft: 25,
        marginTop: 25,
        flexGrow: 0
    },
    card: {
        width: 108,
        height: 115,
        borderTopLeftRadius: 20,
        borderBottomRightRadius: 20,
        marginRight: 15
    },
    img: {
        width: 20,
        height: 20,
        position: 'absolute',
        right: 15,
        top: 13
    },
    textCard: {
        fontFamily: 'Roboto_400Regular',
        position: 'absolute',
        left: 15,
        bottom: 13,
        color: '#fff',
        fontSize: 16
    },
    contentCard: {
        width: 108,
        marginRight: 15,
        borderTopLeftRadius: 20,
        borderBottomRightRadius: 20,
        overflow: 'hidden',
        height: "auto"
    }
});

export default styles;
